import { React } from "react";
import { memo, useState } from "react";
import { Row } from "react-bootstrap";
import CardItemMap from "../srp/CardItemMap";
import { trackButtonClick } from "@/utils/analytics";
import { markInternalNavigation } from "@/utils/attributionCapture";

const NearbyProperties = ({state, propCategory, nearbyProperties, propertyId}) => {
  return (
    <div className="left_side_widget mb20  mt20 tour-pdp-details p0">
      <Row className="propertyInfoBoxHeading p0">
        <h3 className="propertyInfoBoxHeadingText RecommenedProperties">
          {propCategory === "COMMERCIAL"
            ? "Recommended Commercial Properties"
            : "Recommended Properties"}
        </h3>
      </Row>
      <div className="sidebar_feature_property_slider ">
        {nearbyProperties?.length > 0 &&
          nearbyProperties?.slice(0, 3)?.map((card) => {
            const item = {
              ...card,
              propAddress: {
                streetNumber: card?.streetNumber,
                streetName: card?.streetName,
                city: card?.city,
                state: card?.state,
                zip: card?.zip,
              },
              currentBid: card?.currentBid?.replace("$", "") || undefined,
              imageUrl: card?.defaultImageLocation,
            };
            return (
              <div className="nearby-container m20">
                <CardItemMap item={item} isNearbyProperty={true} />
              </div>
            );
          })}
      </div>
      <div className="text-center pb10">
        <a
          className="view-all"
          href={`/near-by?${propCategory === "COMMERCIAL" ? "category=commercial&" : ""}${state ? `state=${state}` : ""}`}
          target="_blank"
          onClick={() => {
            markInternalNavigation();
            trackButtonClick({
              eventName: "recommended_props_view_more_click",
              eventCategory: "NEW-PDP",
              eventSource: "on view more recommended properties click",
              eventLabel: `Property ID: ${propertyId} | Rank:1`,
            });
          }}
        >
          View More Properties
        </a>
      </div>
    </div>
  );
};

export default memo(NearbyProperties);